"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchSystemComponents = exports.getSystemProducts = exports.updateSystem = exports.createSystem = exports.getSystemsService = exports.getSystemComponents = exports.getSystem = exports.getSystemsBySiteId = void 0;
const CustomError_1 = __importDefault(require("@/domains/Utilities/CustomError"));
const api_1 = require("@/services/api");
const ENDPOINT = "/systems";
function getSystemsBySiteId(siteId) {
    return api_1.axiosInstance
        .get(`${ENDPOINT}?filter[siteId]=${siteId}`)
        .then((response) => {
        return response.data.rows;
    })
        .catch((error) => {
        throw new Error(`'[Get Systems by SiteId Error]: ${error}'`);
    });
}
exports.getSystemsBySiteId = getSystemsBySiteId;
function getSystem(systemId) {
    return api_1.axiosInstance
        .get(`${ENDPOINT}/${systemId}`)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Get System Error]: ${error}`);
    });
}
exports.getSystem = getSystem;
function getSystemComponents(systemId) {
    return api_1.axiosInstance
        .get(`${ENDPOINT}/components?filter[id]=${systemId}`)
        .then((response) => {
        return response.data.rows[0].components;
    })
        .catch((error) => {
        throw new Error(`[Get System Components Error]: ${error}`);
    });
}
exports.getSystemComponents = getSystemComponents;
function getSystemsService() {
    return api_1.axiosInstance
        .get(`${ENDPOINT}`)
        .then((response) => {
        return response.data.rows;
    })
        .catch((error) => {
        throw new Error(`'[Get Systems Error]: ${error}'`);
    });
}
exports.getSystemsService = getSystemsService;
function createSystem(payload) {
    return api_1.axiosInstance
        .post(`${ENDPOINT}`, payload)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new CustomError_1.default("Error while creating system", error?.response?.status);
    });
}
exports.createSystem = createSystem;
function updateSystem(systemId, payload) {
    return api_1.axiosInstance
        .put(`${ENDPOINT}/${systemId}`, payload)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new CustomError_1.default("Error while updating system", error?.response?.status);
    });
}
exports.updateSystem = updateSystem;
function getSystemProducts(systemId) {
    return api_1.axiosInstance
        .get(`${ENDPOINT}/${systemId}/products`)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new CustomError_1.default("Error while listing system products", error?.response.status);
    });
}
exports.getSystemProducts = getSystemProducts;
function patchSystemComponents(systemId, payload) {
    return api_1.axiosInstance
        .patch(`${ENDPOINT}/${systemId}`, payload)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new CustomError_1.default("Error while patching system components", error?.response.status);
    });
}
exports.patchSystemComponents = patchSystemComponents;
